// Logistics Email Templates
// Standard email templates for freight forwarding operations

export const EMAIL_TEMPLATES = [
  // ============ ARRIVAL & NOTICE TEMPLATES ============
  {
    id: "arrival_notice",
    name: "Arrival Notice",
    category: "arrival",
    subject: "Arrival Notice – {vessel_voyage} – {bl_number}",
    body: `Dear {customer_name},

Please be advised that the below shipment has arrived / is expected to arrive at {destination_port}.

Vessel: {vessel_voyage}
Port of Discharge: {destination_port}
ETA / ATA: {eta}

B/L No.: {bl_number}
Container No.: {containers}
Seal No.: {seal_number}
Packages / Weight: {cargo_details}

Kindly arrange customs clearance and delivery accordingly.

Please find attached the Arrival Notice and local charges.

Should you require any further assistance, please do not hesitate to contact us.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "change_of_destination",
    name: "COD/CUSTOMER",
    category: "arrival",
    subject: "Change of Destination Request – {bl_number} – {pf_number}",
    body: `Dear {customer_name},

We refer to the below shipment and confirm receipt of your request for a Change of Destination (COD).

B/L No.: {bl_number}
Booking No.: {booking}
Vessel / Voyage: {vessel_voyage}
Current Port of Discharge: {destination_port}
Requested NEW Port of Discharge: {new_destination}
Container No.: {containers}

Please note that a COD is subject to carrier approval and may incur additional charges (COD fee, re-stow, storage / demurrage, and any difference in freight). We will confirm feasibility and costs with the carrier and revert with the amended routing for your approval.

Kindly confirm the following so we can proceed:
1) Final delivery place at the new destination
2) Consignee details at destination (if changed)
3) Your acceptance of the applicable COD charges

We will keep you updated on the approval status.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "cod_ssline",
    name: "COD/SSLINE",
    category: "arrival",
    subject: "COD Request – B/L {bl_number} – Change of Port of Discharge to {new_destination}",
    body: `Dear Team,

We request a Change of Destination (COD) for the following shipment:

B/L number: {bl_number}
Booking number: {booking}
Container number(s): {containers}
Vessel/Voyage: {vessel_voyage}
Current Port of Discharge: {destination_port}
Requested Port of Discharge: {new_destination}
Final destination, if applicable: [FINAL DESTINATION]
Reason for change: [BRIEF REASON]

Please confirm whether the requested change is operationally feasible and advise the applicable COD charges, documentation requirements, revised transit details, and any additional conditions.

The COD charges will be paid by [PARTY NAME AND ROLE].

If the shipping parties must also be amended, the new details are as follows:

Party to be amended: [SHIPPER/CONSIGNEE/NOTIFY PARTY/OTHER]
Company name: [NAME]
Address: [FULL ADDRESS]
Contact person: [NAME]
Telephone: [TELEPHONE]
Email: [EMAIL]

We acknowledge that this request is subject to the carrier's approval, operational feasibility, customs requirements, and payment of all applicable charges.

Please confirm receipt and advise the next steps.

Kind regards,
{sender_name}
Europacific`
  },
  {
    id: "pre_alert",
    name: "Pre-Alert",
    category: "arrival",
    subject: "Pre-Alert – {bl_number} – {vessel_name}",
    body: `Dear Colleagues,

Please find below pre-alert details for the following shipment.

BL No.: {bl_number}
Vessel / Voyage: {vessel_voyage}
Port of Loading: {origin_port}
Port of Discharge: {destination_port}
ETA: {eta}

Cargo Details:
{cargo_details}

Container No.: {containers}

Documents attached:
• BL Copy
• Commercial Invoice
• Packing List

Kindly proceed with arrival procedures.

Best regards,
{sender_name}
Europacific`
  },

  // ============ BL / TELEX RELEASE TEMPLATES ============
  {
    id: "telex_release",
    name: "Telex Release Confirmation",
    category: "bl_release",
    subject: "Telex Release – BL {bl_number}",
    body: `Dear Colleagues,

Please be advised that the original Bill of Lading for the below shipment has been surrendered at origin.

Kindly release the cargo to the consignee without presentation of the original BL.

Shipment details:
BL No.: {bl_number}
Vessel / Voyage: {vessel_voyage}
Container No.: {containers}
Consignee: {customer_name}

Thank you for your cooperation.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "bl_hold",
    name: "Hold BL Until Release",
    category: "bl_release",
    subject: "Hold BL – Shipment {bl_number}",
    body: `Dear {customer_name},

Please issue the Bill of Lading as usual but keep it on HOLD.

Do not release the original BLs or arrange telex release until further instructions from us.

Shipment details:
Shipper: {shipper}
Consignee: {consignee}
Vessel / Voyage: {vessel_voyage}
Container: {containers}

We will advise once the BL can be released.

Thank you.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "bl_release_auth",
    name: "BL Release Authorization",
    category: "bl_release",
    subject: "Authorization to Release BL – {pf_number}",
    body: `Dear {customer_name},

Please proceed with the release of the Bill of Lading for the below shipment.

Shipment details:
BL No.: {bl_number}
Vessel / Voyage: {vessel_voyage}
Container No.: {containers}

You may release the documents to the consignee / arrange telex release accordingly.

Thank you for your assistance.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "bl_amendment",
    name: "BL Amendment Request",
    category: "bl_release",
    subject: "BL Amendment Request – {bl_number}",
    body: `Dear {customer_name},

Kindly amend the BL as follows:

BL No.: {bl_number}

Current: [Incorrect detail]
Correct: [Correct detail]

Please confirm once amended.

Best regards,
{sender_name}
Europacific`
  },

  // ============ DELIVERY & RELEASE TEMPLATES ============
  {
    id: "delivery_order_request",
    name: "Delivery Order Request",
    category: "delivery",
    subject: "Delivery Order Request – BL {bl_number}",
    body: `Dear {customer_name},

Kindly issue the Delivery Order for the below shipment.

BL No.: {bl_number}
Container No.: {containers}
Vessel / Voyage: {vessel_voyage}

All required charges have been settled.

Please advise once the DO is available.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "delivery_scheduling",
    name: "Delivery Scheduling",
    category: "delivery",
    subject: "Delivery Scheduling – Container {containers}",
    body: `Dear {customer_name},

Please advise your preferred delivery date for the following container:

Container No.: {containers}
Terminal: {destination_port}

Available from: {eta}

Kindly confirm your delivery slot.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "delivery_confirmation",
    name: "Delivery Confirmation / POD",
    category: "delivery",
    subject: "Delivery Confirmation – Shipment {pf_number}",
    body: `Dear {customer_name},

Please note that the shipment has been successfully delivered.

Container No.: {containers}
Delivery Date: [DATE]
Delivery Location: {destination_port}

Proof of delivery attached.

Best regards,
{sender_name}
Europacific`
  },

  // ============ CUSTOMS TEMPLATES ============
  {
    id: "customs_clearance_request",
    name: "Customs Clearance Request",
    category: "customs",
    subject: "Customs Clearance Request – Shipment {bl_number}",
    body: `Dear {customer_name},

Please arrange customs clearance for the below shipment.

BL No.: {bl_number}
Container No.: {containers}
Arrival: {eta}

Documents attached:
• Invoice
• Packing List
• BL copy

Please advise once cleared.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "customs_release",
    name: "Customs Release Confirmation",
    category: "customs",
    subject: "Customs Release – Shipment {bl_number}",
    body: `Dear {customer_name},

Please note that the shipment has been released by customs.

BL No.: {bl_number}
Container No.: {containers}

Delivery can proceed.

Best regards,
{sender_name}
Europacific`
  },

  // ============ BOOKING TEMPLATES ============
  {
    id: "booking_confirmation",
    name: "Booking Confirmation",
    category: "booking",
    subject: "Booking Confirmation – {pf_number} – {origin_port} to {destination_port}",
    body: `Dear {customer_name},

Please find below your LCL booking confirmation.

===== LCL BOOKING =====
Booking No.: {booking}
Customer Reference: {pf_number}
Date: [DATE]

----- ROUTING -----
Routing: {origin_port} to {destination_port}
Vessel / Voyage: {vessel_voyage}
Carrier SCAC: [CARRIER SCAC]
Place of Receipt: {origin_port}
Port of Loading: {origin_port}
Port of Discharge: {destination_port}
Deconsolidation CFS: [DECONSOLIDATION CFS]
Final Destination: [FINAL DESTINATION]
ETD: {etd}
ETA: {eta}
Shipping Terms: CFS / CFS

----- CUT-OFF TIMES -----
Doc Cut-off: [DOC CUT-OFF DATE & TIME]
CFS / Cargo Cut-off: [CFS CUT-OFF DATE & TIME]

----- CARGO DELIVERY AT -----
Warehouse: [WAREHOUSE NAME]
Address: [WAREHOUSE ADDRESS]

----- CARGO DETAILS -----
Marks & Numbers: [MARKS]
Description of Goods: {cargo_details}
Pieces: [PIECES]
Weight: {cargo_weight} kg
Volume: [VOLUME CBM]

Please proceed with cargo delivery according to the cut-off times above.
The above booking number must appear on all delivery papers to ensure acceptance of cargo at our warehouse.

Should you require any further assistance, please do not hesitate to contact us.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "sailing_confirmation",
    name: "Sailing Confirmation",
    category: "booking",
    subject: "Sailing Confirmation – Booking {booking} – {pf_number}",
    body: `Dear {customer_name},

We are pleased to confirm that the below shipment has sailed.

===== SAILING CONFIRMATION =====
Booking No.: {booking}
Lot Number: [LOT NUMBER]
Confirmed Actual Time of Sailing: {etd}

----- SHIPMENT REFERENCES -----
Customer Reference: {pf_number}
Shipment Reference: {origin_port} to {destination_port}
Bill of Lading: {bl_number}

----- ROUTING -----
Vessel / Voyage: {vessel_voyage}
Port of Loading: {origin_port} — ATS / ETD: {etd}
Port of Discharge: {destination_port} — ETA: {eta}
Deconsolidation CFS: [DECONSOLIDATION CFS] — ETA: [CFS ETA]
Final Destination: [FINAL DESTINATION] — ETA: [DESTINATION ETA]

----- CONTAINER DETAILS -----
Carrier: {carrier}
Container No.: {containers}
Seal No.: {seal_number}

----- CARGO DETAILS -----
Marks & Numbers: [MARKS]
Description of Goods: {cargo_details}
Pieces: [PIECES]
Weight: {cargo_weight} kg
Volume: [VOLUME CBM]

Please note: the above booking number must appear on all delivery papers to ensure acceptance of cargo at our warehouse.

Should you require any further assistance, please do not hesitate to contact us.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "cargo_receipt_notice",
    name: "Cargo Receipt Notice (CRN)",
    category: "booking",
    subject: "Cargo Receipt Notification – Booking {booking} – {pf_number}",
    body: `Dear {customer_name},

Please be advised that we have received the following cargo in our {origin_port} terminal under your name. Unless the cargo is on hold or we receive contrary instructions from you, this cargo will be shipped on the stated vessel to the indicated destination.

===== CARGO RECEIPT NOTIFICATION =====
Our Ref: {booking}
Shipper's Ref: {pf_number}
Date: [DATE]

----- SHIPMENT DETAILS -----
Booking No.: {booking}
Delivery Reference: [DELIVERY REFERENCE]
Customs Document Reference (MRN): [MRN]
Destination: {destination_port}
Vessel / Voyage: {vessel_voyage}
ETD: {etd}
Hazardous Class: [N/A]

----- CARGO SUMMARY -----
Booked as:   Pieces [PIECES]  |  Weight {cargo_weight} kg  |  Volume [VOLUME CBM]
Received as: Pieces [RECEIVED PIECES]  |  Weight [RECEIVED WEIGHT] kg  |  Volume [RECEIVED CBM]

Description of packages and goods:
{cargo_details}

Please note: the customer warrants that the gross weight provided is the true and accurate weight of the cargo in accordance with SOLAS Chapter VI. Absence of a verified gross weight will result in the cargo not being shipped.

Should you have any questions, please contact us.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "shipping_instructions",
    name: "Shipping Instructions",
    category: "booking",
    subject: "Shipping Instructions – Booking {pf_number}",
    body: `Dear {customer_name},

Please find attached Shipping Instructions for the below booking.

Booking No.: {pf_number}
Shipper: {shipper}
Consignee: {consignee}
Vessel / Voyage: {vessel_voyage}

Kindly confirm once received and proceed with BL draft.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "bl_draft_approval",
    name: "BL Draft Approval",
    category: "booking",
    subject: "BL Draft Approval – {pf_number}",
    body: `Dear {customer_name},

We confirm that the BL draft is approved.

Please proceed with issuing the Bill of Lading accordingly.

Thank you.

Best regards,
{sender_name}
Europacific`
  },

  // ============ CONTAINER TEMPLATES ============
  {
    id: "container_pickup",
    name: "Container Pickup Authorization",
    category: "container",
    subject: "Container Pickup Authorization – {pf_number}",
    body: `Dear {customer_name},

Please arrange pickup for the following container(s):

Booking No.: {pf_number}
Container Type: {container_type}
Pickup Depot: {origin_port}

Cargo ready date: {etd}

Kindly confirm once collected.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "container_gate_out",
    name: "Container Gate-Out Confirmation",
    category: "container",
    subject: "Container Gate-Out – {containers}",
    body: `Dear {customer_name},

Please note that the following container has been picked up from the terminal.

Container No.: {containers}
Pickup Date: [DATE]
Terminal: {origin_port}

Cargo is now in transit to the loading location.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "container_return",
    name: "Container Return Confirmation",
    category: "container",
    subject: "Container Return Confirmation – {containers}",
    body: `Dear {customer_name},

Please note that the following container has been returned empty.

Container No.: {containers}
Return Depot: {destination_port}
Return Date: [DATE]

Kindly confirm receipt in your system.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "vgm_submission",
    name: "VGM Submission",
    category: "container",
    subject: "VGM Submission – Container {containers}",
    body: `Dear {customer_name},

Please find the Verified Gross Mass for the following container.

Container No.: {containers}
VGM: {cargo_weight} kg
Method: Method 1 / Method 2

Kindly confirm receipt.

Best regards,
{sender_name}
Europacific`
  },

  // ============ CHARGES & INVOICE TEMPLATES ============
  {
    id: "local_charges",
    name: "Local Charges / Freight Invoice",
    category: "charges",
    subject: "Local Charges – Shipment {bl_number}",
    body: `Dear {customer_name},

Please find attached the invoice for local charges related to the below shipment.

BL No.: {bl_number}
Vessel / Voyage: {vessel_voyage}
Container No.: {containers}

Kindly arrange payment in order to proceed with cargo release.

Should you have any questions, please feel free to contact us.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "demurrage_warning",
    name: "Demurrage / Detention Warning",
    category: "charges",
    subject: "Demurrage Warning – Container {containers}",
    body: `Dear {customer_name},

Please note that demurrage / detention charges may apply if the container is not collected within the free time period.

Container No.: {containers}
Free time until: [DATE]

Kindly arrange pickup to avoid additional costs.

Best regards,
{sender_name}
Europacific`
  },

  // ============ DELAY & STATUS TEMPLATES ============
  {
    id: "delay_notice",
    name: "Cargo Delay Notification",
    category: "status",
    subject: "Shipment Delay Notice – {bl_number}",
    body: `Dear {customer_name},

Please be advised that the below shipment is delayed.

BL No.: {bl_number}
Vessel: {vessel_name}

Reason: [Port congestion / schedule change]

Revised ETA: {eta}

We will keep you updated.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "documents_received",
    name: "Documents Received",
    category: "status",
    subject: "Documents Received – {pf_number}",
    body: `Dear {customer_name},

We confirm the safe receipt of the following documents:

• [Document Name 1]
• [Document Name 2]
• [Document Name 3]

All documents have been received in good order and are currently under review / being processed accordingly.

Shipment reference: {pf_number}

Should we require any additional information or clarification, we will contact you promptly.

Thank you for your cooperation.

Kind regards,
{sender_name}
Europacific`
  },
  {
    id: "missing_documents",
    name: "Missing Documents Request",
    category: "status",
    subject: "Request for Missing Documents – {pf_number}",
    body: `Dear {customer_name},

Kindly provide the following documents required for shipment processing:

• [Document 1]
• [Document 2]

Shipment reference: {pf_number}

Thank you for your cooperation.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "status_update",
    name: "Shipment Status Update",
    category: "status",
    subject: "Status Update – Shipment {pf_number}",
    body: `Dear {customer_name},

Please find below the current status of your shipment.

PF Reference: {pf_number}
BL No.: {bl_number}
Vessel / Voyage: {vessel_voyage}
Container No.: {containers}

Current Status: {status}
ETA: {eta}

Should you have any questions, please contact us.

Best regards,
{sender_name}
Europacific`
  },
  // ============ PICKUP & COLLECTION TEMPLATES (2026-05-14, Rok) ============
  {
    id: "pickup_request",
    name: "Pickup Request",
    category: "pickup",
    subject: "Pickup Request – {pf_number}",
    body: `Dear {customer_name},

We would like to arrange pickup for the following shipment:

Shipment Reference: {pf_number}
Container / Cargo: {containers} / {cargo_details}
Pickup Location: {pickup_location}
Ready Date: {pickup_date}

Please confirm:
- Pickup date
- Cargo readiness
- Contact person on site
- Loading instructions

Kindly revert at your earliest convenience.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_confirmation",
    name: "Pickup Confirmation",
    category: "pickup",
    subject: "Pickup Confirmation – {pf_number}",
    body: `Dear {customer_name},

Pickup has been successfully arranged.

Details:
Pickup Date: {pickup_date}
Pickup Time: {pickup_time}
Driver / Vehicle: {driver} / {truck}
Location: {pickup_location}

Please ensure cargo is ready for loading.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_appointment_request",
    name: "Pickup Appointment Request",
    category: "pickup",
    subject: "Pickup Appointment Request – {pf_number}",
    body: `Dear Team,

Please arrange a pickup appointment for the following shipment:

Reference: {pf_number}
Container / Cargo: {containers} / {cargo_details}
Requested Pickup Date: {pickup_date}

Please confirm available slot.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_appointment_confirmed",
    name: "Pickup Appointment Confirmed",
    category: "pickup",
    subject: "Pickup Appointment Confirmed – {pf_number}",
    body: `Dear {customer_name},

The pickup appointment has been confirmed.

Date: {pickup_date}
Time: {pickup_time}
Warehouse: {pickup_location}

Please share any additional instructions if required.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "cargo_ready_pickup",
    name: "Cargo Ready for Pickup",
    category: "pickup",
    subject: "Cargo Ready for Pickup – {pf_number}",
    body: `Dear {customer_name},

Please be informed that the cargo is ready for pickup.

Shipment Reference: {pf_number}
Pickup Address: {pickup_location}
Ready From: {pickup_date} {pickup_time}

Kindly arrange collection accordingly.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_driver_details",
    name: "Driver Details for Pickup",
    category: "pickup",
    subject: "Driver Details – Pickup {pf_number}",
    body: `Dear {customer_name},

Please find pickup driver details below:

Driver Name: {driver}
Truck Plate: {truck}
Phone Number: {phone}
Pickup Date: {pickup_date}

Kindly allow loading upon arrival.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_delay_notice",
    name: "Pickup Delay Notice",
    category: "pickup",
    subject: "Pickup Delay Notice – {pf_number}",
    body: `Dear {customer_name},

Please note that pickup for the following shipment has been delayed:

Reference: {pf_number}

New estimated pickup time/date:
{pickup_date} {pickup_time}

We apologize for the inconvenience and will keep you updated.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_failed",
    name: "Failed Pickup Attempt",
    category: "pickup",
    subject: "Failed Pickup Attempt – {pf_number}",
    body: `Dear {customer_name},

Unfortunately, pickup could not be completed due to the following reason:

[REASON]

Shipment Reference: {pf_number}

Please advise next steps or provide a new pickup schedule.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_completed",
    name: "Pickup Completed",
    category: "pickup",
    subject: "Pickup Completed – {pf_number}",
    body: `Dear {customer_name},

We confirm successful pickup of the shipment.

Reference: {pf_number}
Pickup Date: {pickup_date}
Cargo Details: {cargo_details}

The shipment is now in transit.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_empty_container",
    name: "Empty Container Pickup",
    category: "pickup",
    subject: "Empty Container Pickup – {containers}",
    body: `Dear {customer_name},

Please arrange pickup of the empty container below:

Container Number: {containers}
Pickup Location: {pickup_location}
Availability Date: {pickup_date}

Please confirm collection timing.

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_export_instructions",
    name: "Export Cargo Pickup Instruction",
    category: "pickup",
    subject: "Export Pickup Instructions – {pf_number}",
    body: `Dear Transport Team,

Please arrange pickup for export cargo as follows:

Reference: {pf_number}
Pickup Address: {pickup_location}
Cargo Details: {cargo_details}
Cutoff Date: {pickup_date}

Special Instructions:
[NOTES]

Best regards,
{sender_name}
Europacific`
  },
  {
    id: "pickup_documents_request",
    name: "Pickup Documents Request",
    category: "pickup",
    subject: "Documents Required Before Pickup – {pf_number}",
    body: `Dear {customer_name},

Before pickup can be arranged, kindly provide:

- Commercial Invoice
- Packing List
- Loading Reference
- Customs Documents (if applicable)

Shipment Reference: {pf_number}

Best regards,
{sender_name}
Europacific`
  }
];

// Template categories for grouping
export const TEMPLATE_CATEGORIES = [
  { id: "arrival", name: "Arrival & Notice", icon: "Ship" },
  { id: "bl_release", name: "BL / Telex Release", icon: "FileText" },
  { id: "delivery", name: "Delivery & Release", icon: "Truck" },
  { id: "pickup", name: "Pickup & Collection", icon: "Package" },
  { id: "customs", name: "Customs", icon: "Shield" },
  { id: "booking", name: "Booking", icon: "Calendar" },
  { id: "container", name: "Container", icon: "Package" },
  { id: "charges", name: "Charges & Invoice", icon: "DollarSign" },
  { id: "status", name: "Status Updates", icon: "Bell" }
];

// Helper function to fill template with PF data
export const fillTemplate = (template, folder, senderName = "") => {
  // Derive values from whatever field names this PF happens to use so drafts
  // are prefilled with as much real shipment info as possible.
  const hblStr = folder.hbl_number
    || (Array.isArray(folder.hbl_numbers) ? folder.hbl_numbers.filter(Boolean).join(", ") : folder.hbl_numbers)
    || "";
  const blStr = folder.mbl_number || hblStr || folder.bl_number || "";
  const containersStr = Array.isArray(folder.containers)
    ? folder.containers.filter(Boolean).join(", ")
    : (folder.containers || folder.container_number || "");
  const carrierStr = folder.shipping_line || folder.carrier || folder.carrier_name || "";
  const originStr = folder.origin_port || folder.port_of_loading || folder.pol || "";
  const destStr = folder.destination_port || folder.port_of_discharge || folder.pod || "";
  const weightStr = folder.gross_weight_kg || folder.cargo_weight || folder.gross_weight || "";

  const replacements = {
    "{pf_number}": folder.pf_number || "[PF NUMBER]",
    "{customer_name}": folder.customer || folder.customer_name || "[CUSTOMER NAME]",
    "{bl_number}": blStr || "[BL NUMBER]",
    "{mbl_number}": folder.mbl_number || "[MBL NUMBER]",
    "{hbl_number}": hblStr || "[HBL NUMBER]",
    "{carrier}": carrierStr || "[CARRIER]",
    "{vessel_name}": folder.vessel_name || "[VESSEL]",
    "{vessel_voyage}": folder.vessel_name && folder.voyage ? `${folder.vessel_name} / ${folder.voyage}` : folder.vessel_name || "[VESSEL / VOYAGE]",
    "{voyage}": folder.voyage || "[VOYAGE]",
    "{origin_port}": originStr || "[PORT OF LOADING]",
    "{destination_port}": destStr || "[PORT OF DISCHARGE]",
    "{new_destination}": (folder.cod && folder.cod.new_destination) || "[NEW DESTINATION]",
    "{eta}": folder.eta ? new Date(folder.eta).toLocaleDateString() : "[ETA]",
    "{etd}": folder.etd ? new Date(folder.etd).toLocaleDateString() : "[ETD]",
    "{containers}": containersStr || "[CONTAINER NO.]",
    "{seal_number}": folder.seal_number || "[SEAL]",
    "{cargo_details}": folder.description || folder.cargo_description || folder.commodity || "[CARGO DETAILS]",
    "{cargo_weight}": weightStr || "[WEIGHT]",
    "{container_type}": folder.container_type || folder.service_type || "[CONTAINER TYPE]",
    "{shipper}": folder.shipper || "[SHIPPER]",
    "{consignee}": folder.consignee || "[CONSIGNEE]",
    "{status}": folder.status || "[STATUS]",
    // Pickup & Collection placeholders (2026-05-14, Rok). Fall back to a
    // visible bracket so the operator knows what to fill in manually.
    "{pickup_location}": folder.pickup_location || folder.collection_address
                          || folder.origin_address || "[PICKUP LOCATION]",
    "{pickup_date}":     folder.pickup_date || folder.collection_date
                          || folder.cargo_ready_date || "[PICKUP DATE]",
    "{pickup_time}":     folder.pickup_time || "[PICKUP TIME]",
    "{driver}":          folder.driver_name || folder.driver || "[DRIVER]",
    "{truck}":           folder.truck_plate || folder.truck || "[TRUCK PLATE]",
    "{phone}":           folder.driver_phone || folder.contact_phone || "[PHONE]",
    "{booking}":         folder.booking_number || "[BOOKING]",
    "{ref}":             folder.pf_number || folder.reference || "",
    "{sender_name}":     senderName || "[YOUR NAME]"
  };

  // Final pass: replace any unfilled "{...}" placeholders with bracketed
  // versions like [PLACEHOLDER] so they stay visible to the user. We don't
  // want stray `{pickup_time}` placeholders leaking into the customer email.
  let filledSubject = template.subject;
  let filledBody = template.body;

  for (const [placeholder, value] of Object.entries(replacements)) {
    filledSubject = filledSubject.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
    filledBody = filledBody.replace(new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'), value);
  }

  // Catch any stray placeholders we forgot — convert to BRACKET form.
  filledSubject = filledSubject.replace(/\{([a-z_]+)\}/gi,
    (_, k) => `[${k.toUpperCase().replace(/_/g, ' ')}]`);
  filledBody = filledBody.replace(/\{([a-z_]+)\}/gi,
    (_, k) => `[${k.toUpperCase().replace(/_/g, ' ')}]`);

  return { subject: filledSubject, body: filledBody };
};
